import { instance } from '../lib/api'
import { API_FAIL, IS_STATUS_ONLINE, setStatus } from './dashboard'
import { SHOW_SNACKBAR_TOASTR } from './loading'
import Constants from '../utils/CommonConstants'

export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAIL = 'LOGOUT_FAIL'
export const OFFLINE_STATE = 'OFFLINE_STATE'
export const UPDATE_MASTER_CASE_REASONS_MAP = 'UPDATE_MASTER_CASE_REASONS_MAP'
export const UPDATE_CASE_STATUS_MAP = 'UPDATE_CASE_STATUS_MAP'
export const UPDATE_PAYMENT_STATUS_MAP = 'UPDATE_PAYMENT_STATUS_MAP'
export const SET_DEFAULT_STATE = 'SET_DEFAULT_STATE'

const extractBasicDetails = userDetails => {
  const { id, email, firstName, lastName, contactNumber, roles } = userDetails
  return { id, email, firstName, lastName, contactNumber, roles }
}

export const logout = toggleLoader => dispatch => {
  const url = '/madrox/app/v1/logout'
  return instance({
    url,
    method: 'post'
  })
    .then(() => {
      dispatch({
        type: LOGOUT_SUCCESS,
        userInfo: null
      })
      toggleLoader(false)
    })
    .catch(() => {
      dispatch({
        type: LOGOUT_FAIL
      })
      toggleLoader(false)
    })
}

const logoutUnauthorizedUser = () => {
  const url = '/madrox/app/v1/logout'
  instance({
    url,
    method: 'post'
  })
    .then(() => {})
    .catch(() => {})
}

function dispatchLoginSuccess({
  dispatch,
  isRcmUser,
  isRcmAdmin,
  isSalesUser,
  isRcmView,
  user
}) {
  dispatch({
    type: LOGIN_SUCCESS,
    isSalesRoleOnly: !isRcmUser && isSalesUser,
    isRcmAdmin,
    userInfo: extractBasicDetails(user),
    isRcmView
  })
  dispatch({
    type: IS_STATUS_ONLINE,
    isStatusOnline: false
  })
}

export const getCaseStatusMap = () => dispatch => {
  const url = Constants.configUrls.CASE_STATUS_MAP()
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const caseStatusMap = {}
      response.data.data.results.forEach(item => {
        caseStatusMap[item.id] = item.status
      })
      dispatch({
        type: UPDATE_CASE_STATUS_MAP,
        caseStatusMap
      })
    })
    .catch(() => {
      dispatch({
        type: API_FAIL
      })
    })
}

export const getReasonsMap = () => dispatch => {
  const url = Constants.configUrls.MASTER_REASON_LIST()
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const masterReasonMap = {}
      response.data.data.results.forEach(item => {
        masterReasonMap[item.id] = item.reason
      })
      dispatch({
        type: UPDATE_MASTER_CASE_REASONS_MAP,
        masterReasonMap
      })
    })
    .catch(() => {
      dispatch({
        type: API_FAIL
      })
    })
}

export const getPaymentStatusMap = () => dispatch => {
  const url = Constants.configUrls.PAYMENT_STATUS_MAP()
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const paymentStatusMap = {}
      response.data.data.data.forEach(item => {
        paymentStatusMap[item.id] = item.name
      })
      dispatch({
        type: UPDATE_PAYMENT_STATUS_MAP,
        paymentStatusMap
      })
    })
    .catch(() => {
      dispatch({
        type: API_FAIL
      })
    })
}

const getAccessAttrs = roles => {
  let isRcmUser
  let isSalesUser
  let isRcmAdmin
  let isRcmView
  isRcmAdmin = isRcmUser = isSalesUser = isRcmView = false
  roles.forEach(role => {
    switch (role) {
      case Constants.roles.rcmUser:
        isRcmUser = true
        break
      case Constants.roles.rcmView:
        isRcmView = true
        break
      case Constants.roles.housingSalesAgent:
      case Constants.roles.housingSalesManager:
        isSalesUser = true
        break
      case Constants.roles.rcmAdmin:
        isRcmAdmin = true
    }
  })
  return { isRcmAdmin, isRcmUser, isSalesUser, isRcmView }
}

export const getUser = () => dispatch => {
  const url = '/madrox/app/v1/user/details'
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const user = response.data.data
      const { isRcmUser, isSalesUser, isRcmAdmin, isRcmView } = getAccessAttrs(
        user.roles || []
      )
      if (isRcmUser || isSalesUser || isRcmAdmin || isRcmView) {
        dispatch({
          type: LOGIN_SUCCESS,
          isSalesRoleOnly: !isRcmUser && isSalesUser,
          isRcmAdmin,
          userInfo: extractBasicDetails(user)
        })
      } else {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: "You don'n have sufficient permissions."
        })
        logoutUnauthorizedUser()
      }
    })
    .catch(() => {
      dispatch({
        type: OFFLINE_STATE
      })
    })
}

export const setDefaultState = () => dispatch => {
  dispatch({
    type: SET_DEFAULT_STATE
  })
}

export const loadGoogleScript = () =>
  new Promise((resolve, reject) => {
    if (window.google && window.google.accounts) {
      resolve(window.google.accounts)
      return
    }

    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.onload = () => {
      resolve(window.google.accounts)
    }

    script.onerror = error => {
      reject(new Error('Failed to load Google API script:', error))
    }
    document.body.appendChild(script)
  })

export const doSocialLogin = (accessToken, toggleLoader) => {
  const url = `madrox/app/v1/login/google?access_token=${accessToken}`
  return dispatch =>
    instance({
      url,
      method: 'get'
    })
      .then(response => {
        const { data: { data: user } = {} } = response || {}
        const { isRcmUser, isSalesUser, isRcmAdmin, isRcmView } =
          getAccessAttrs(user.roles || [])
        if (isRcmUser || isSalesUser || isRcmAdmin || isRcmView) {
          dispatchLoginSuccess({
            dispatch,
            isRcmUser,
            isRcmAdmin,
            isSalesUser,
            isRcmView,
            user
          })
        } else {
          dispatch({
            type: API_FAIL,
            errMsg: "You don't have sufficient permissions."
          })
          logoutUnauthorizedUser()
        }
        toggleLoader(false)
      })
      .catch(error => {
        const {
          response: { data: { error: { msg = 'Login Failed' } = {} } = {} } = {}
        } = error || {}
        dispatch({
          type: API_FAIL,
          errMsg: msg
        })
        toggleLoader(false)
      })
}



/** WEBPACK FOOTER **
 ** ./src/actions/login.js
 **/